/**
 * Shared pricing constants used across Pricing.tsx and PendingHome.tsx.
 * Single source of truth for feature lists and pricing figures.
 */

export const unlimitedPlanFeatures = [
  'Unlimited appraisals — residential & commercial',
  'USPAP-compliant report templates',
  'Complete workfile management',
  'NJ Public Record data pulls',
  'Business analytics dashboard',
  'Engagement letter generator',
  'Trainee management tools',
  'Priority support',
];

export const websiteAddonFeatures = [
  'Professional appraiser website',
  'Custom subdomain hosting',
  'SEO-optimized landing pages',
  'Lead capture forms',
  'Custom branding & theming',
];

export const websiteStandaloneNote = 'No appraisal subscription required';

export const enterpriseFeatures = [
  'Unlimited seats at per-user pricing',
  'Centralized billing & management',
  'Configurable data ownership policies',
  'USPAP-compliant retention access',
  'Dedicated support & onboarding',
  'Bypass all team & member limits',
];

/**
 * Published 2026 list pricing for the entry and top tiers of the GSE-verified
 * UAD 3.6 platforms we compete against. Deliberately unnamed and stated as a
 * range: naming a competitor means the page goes stale the moment they discount.
 * Re-check annually.
 */
export const LENDER_PLATFORM = {
  floorAnnual: 1500,
  ceilingAnnual: 3500,
} as const;

/** Pricing figures */
export const PRICING = {
  unlimited: {
    monthly: 99,
    annual: 990,
    monthlySavingsLabel: '$82.50/mo effective — save $198/year',
  },
  websiteAddon: 25,
  websiteStandalone: 40,
  creditBase: 15,
} as const;
